import dayjs from '@/utils/day';

export const getNumberOfNights = (date1, date2) => {
  const start = dayjs(date1);
  const end = dayjs(date2);
  return end.diff(start, 'day');
};
